import Router from 'vue-router'

export default new Router({
  mode: "history",
  routes: [
    {
      path: '/',
      component: () => import('@/views/main.vue'),
      redirect: '/home',
      children: [
        {
          path: 'home',
          name: 'home',
          component: () => import('@/views/home.vue')
        },
        {
          path: 'join',
          name: 'join',
          component: () => import('@/views/join/index.vue')
        },
        {
          path: '/join/search',
          name: 'join',
          meta: {
            keepAlive: true,
          },
          component: () => import('@/views/join/search/index.vue')
        },
        {
          path: '/join/detail/:id',
          name: 'join',
          component: () => import('@/views/join/detail.vue')
        },
        {
          path: 'connection',
          name: 'connection',
          component: () => import('@/views/connection.vue')
        },
        {
          path: 'about',
          name: 'about',
          component: () => import('@/views/about.vue')
        },

        // 新闻
        {
          path: 'news',
          name: 'news',
          component: () => import('@/views/news/index.vue')
        },
        // {
        //   path: '/news/list',
        //   name: 'NewsList',
        //   component: import('@/views/news/list.vue')      
        // },
        {
          path: '/news/detail/:id',
          name: 'NewsDetail',
          component: () => import('@/views/news/detail.vue')      
        },
      ]
    }
  ]
})